import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

// FontAwesome "align-left" (solid), inlined from the estimateNext design — the work order's Product
// Description label. Four alternating long/short rounded bars; MUI's Subject is lighter and sits on a
// different rhythm. Inherits color via `currentColor`.
const AlignLeftIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path d="M1.6 3.2C1.6 2.7582 1.9582 2.4 2.4 2.4H13.6C14.0418 2.4 14.4 2.7582 14.4 3.2C14.4 3.6418 14.0418 4 13.6 4H2.4C1.9582 4 1.6 3.6418 1.6 3.2ZM1.6 6.9333C1.6 6.4915 1.9582 6.1333 2.4 6.1333H9.6C10.0418 6.1333 10.4 6.4915 10.4 6.9333C10.4 7.3751 10.0418 7.7333 9.6 7.7333H2.4C1.9582 7.7333 1.6 7.3751 1.6 6.9333ZM1.6 10.6667C1.6 10.2249 1.9582 9.8667 2.4 9.8667H13.6C14.0418 9.8667 14.4 10.2249 14.4 10.6667C14.4 11.1085 14.0418 11.4667 13.6 11.4667H2.4C1.9582 11.4667 1.6 11.1085 1.6 10.6667ZM1.6 14.4C1.6 13.9582 1.9582 13.6 2.4 13.6H9.6C10.0418 13.6 10.4 13.9582 10.4 14.4C10.4 14.8418 10.0418 15.2 9.6 15.2H2.4C1.9582 15.2 1.6 14.8418 1.6 14.4Z" />
  </SvgIcon>
)
export default AlignLeftIcon
